import * as React from 'react';
import { compose, defaultProps, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import { FontIcon } from '../FontIcon';
import { setProp, toCssValue } from '@topconagriculture/theme';
import classNames from 'classnames';
const styles = (theme) => createStyles({
    root: {
        padding: toCssValue([3, 15, 4]),
        textTransform: 'uppercase',
        fontSize: theme.font.size.small,
        fontWeight: theme.font.weight.bold,
        color: theme.color.font.light,
        backgroundColor: theme.color.grey.default,
        borderRadius: theme.common.borderRadius.high,
        display: 'flex',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    fixedSize: {
        display: 'block',
        minWidth: 100,
        width: 160,
        boxSizing: 'border-box',
    },
    chipIcon: {
        lineHeight: 0.6,
    },
});
const Chip = (props) => {
    const { classes, className: classNameProp, label, icon, bgColor, labelColor, labelSize, fixedSize, title, testId = 'Chip', onIconClick = () => null, } = props;
    const chipClasses = classNames(classNameProp, classes.root, {
        [classes.fixedSize]: fixedSize,
    });
    let inlineStyles = {};
    inlineStyles = setProp(inlineStyles, 'background', bgColor);
    inlineStyles = setProp(inlineStyles, 'color', labelColor);
    inlineStyles = setProp(inlineStyles, 'fontSize', labelSize);
    const iconEl = icon && (React.createElement(FontIcon, { size: labelSize, marginRight: 8, iconName: icon, color: labelColor, className: classes.chipIcon, onClick: onIconClick }));
    return (React.createElement("div", { "data-testid": `${testId}`, className: chipClasses, style: inlineStyles, title: title },
        iconEl,
        label));
};
const ComposedChip = compose(pure, withStyles(styles, { withTheme: true }), defaultProps({
    labelSize: 11,
    fixedSize: false,
}))(Chip);
ComposedChip.displayName = 'Chip';
export default ComposedChip;
//# sourceMappingURL=Chip.js.map